import { OdataManager } from '@/api/odata/odata-manager';
import { DocumentCategory } from '@/api/model/interfaces';

export default class DocumentCategoryOdata extends OdataManager<DocumentCategory> {}
